import { render, staticRenderFns } from "./combineEdit.vue?vue&type=template&id=020a5d50&scoped=true"
import script from "./combineEdit.vue?vue&type=script&lang=js"
export * from "./combineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a5d50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020a5d50')) {
      api.createRecord('020a5d50', component.options)
    } else {
      api.reload('020a5d50', component.options)
    }
    module.hot.accept("./combineEdit.vue?vue&type=template&id=020a5d50&scoped=true", function () {
      api.rerender('020a5d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/resource/combineEdit.vue"
export default component.exports